import { Action } from 'cadenza/action';

const WAITING_FOR_BACKEND_CLASS = 'd-selection-cart--actions-waiting-for-backend';

/**
 * Add the ability to display a 'cursor spinner' while the action is executing.
 */
export class SelectionCartAction extends Action {
  onExecuteStart() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add(WAITING_FOR_BACKEND_CLASS);
  }

  onExecuteEnd() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove(WAITING_FOR_BACKEND_CLASS);
  }
}
